import { memo, useCallback, useEffect } from 'react';
import ListItem from '@mui/material/ListItem';
import { useParams, useNavigate } from 'react-router-dom';
// Local files
import { ItemTitle, ItemSubtitle, StyledListItemButton } from './Item.styled';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useManagers from 'hooks/useManagers';
import useCustomSelector from 'hooks/useCustomSelector';
import { managersSelectors } from 'features/managers';

const Item = ({ id, first_name, last_name, email }) => {
  const { user_id } = useParams();
  const navigate = useNavigate();
  const { getManager } = useManagers();
  const fetching = useCustomSelector(managersSelectors.managerIsFetching)

  const handleSelectManager = (e) => { 
    e.stopPropagation();
    id !== user_id && navigate(`/users/${id}`) 
  };
  const fetchManager = useCallback((manager_id) => {
    getManager(manager_id)
  }, [getManager]);

  useEffect(() => {
    !!user_id && id === user_id && fetchManager(user_id);
  }, [id, user_id, fetchManager]);

  return (
    <ListItem disablePadding>
      <StyledListItemButton selected={id === user_id} disabled={fetching} onClick={handleSelectManager}>
        <ItemTitle>{first_name} {last_name}</ItemTitle>
        <ItemSubtitle>{email}</ItemSubtitle>
      </StyledListItemButton>
    </ListItem>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Item {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);